import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["update", "onCompleted"],
    _excluded2 = ["update"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMutation } from '@apollo/client';
import * as E from 'fp-ts/Either';
import { absurd, flow, pipe } from 'fp-ts/function';
import { useApolloResult } from '../use-apollo-result';
import { makeDecodeError } from './make-extended-decoded-query';

// Since this function is only allowed to be used when wrapping fetch errors and
// it contains an unsafe cast, it is private to this file.
var makeGraphQLErrors = function makeGraphQLErrors(errors) {
  return {
    _tag: 'graphql',
    errors: errors
  };
};

export var foldFetchError = function foldFetchError(onGraphQLErrors, onDecodeError) {
  return function (fetchError) {
    if (fetchError._tag === 'graphql') return onGraphQLErrors(fetchError.errors);else if (fetchError._tag === 'decoding') return onDecodeError(fetchError.errors);else return absurd(fetchError);
  };
};

var decodeFetchResultWith = function decodeFetchResultWith(output) {
  return function (result) {
    return result.errors ? E.left(makeGraphQLErrors(result.errors)) : pipe(result.data, output.decode, E.mapLeft(makeDecodeError));
  };
};

export function makeDecodedMutation(mutation, output) {
  var decodeFetchResult = decodeFetchResultWith(output);
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var update = _ref.update,
        onCompleted = _ref.onCompleted,
        options = _objectWithoutProperties(_ref, _excluded);

    var _useMutation = useMutation(mutation, _objectSpread({
      update: update === undefined ? undefined : function (cache, result) {
        return update(cache, decodeFetchResult(result));
      },
      onCompleted: onCompleted === undefined ? undefined : flow(output.decode, onCompleted)
    }, options)),
        _useMutation2 = _slicedToArray(_useMutation, 2),
        apolloMutation = _useMutation2[0],
        mutationResult = _useMutation2[1];

    var result = useApolloResult(_objectSpread(_objectSpread({}, mutationResult), {}, {
      output: output
    }));
    return [function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var update = _ref2.update,
          rest = _objectWithoutProperties(_ref2, _excluded2);

      return apolloMutation(_objectSpread({
        update: update === undefined ? undefined : function (cache, result) {
          return update(cache, decodeFetchResult(result));
        }
      }, rest)).then(decodeFetchResult);
    }, result];
  };
}